import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";
import Billing from "@/services/billing/billing";

export interface AddOnGroup {
  id: string; // OrgPowerUp.id — used as v-for key
  key: string;
  name: string;
  icon: string;
  identifier: string | null; // formatted phone / email / LinkedIn name / WhatsApp number
  monthlyCents: number;
  isIncluded: boolean;
}

const POWERUP_ICON: Record<string, string> = {
  local_number: "mdi:phone",
  linkedin_messaging: "mdi:linkedin",
  whatsapp_messaging: "mdi:whatsapp",
  additional_email: "mdi:email-outline",
};

const POWERUP_DISPLAY_NAME: Record<string, string> = {
  local_number: "Phone",
  linkedin_messaging: "LinkedIn",
  whatsapp_messaging: "WhatsApp",
  additional_email: "Email",
};

export function useActivePowerUps(orgId: Ref<string | null | undefined>) {
  return useQuery({
    queryKey: computed(() => ["billing", "activePowerUps", orgId.value] as const),
    queryFn: async () => {
      const result = await Billing.getActivePowerUps(orgId.value!);
      const payload = result?.data as { status?: boolean; data?: unknown[] };
      const items = payload?.status && Array.isArray(payload.data) ? (payload.data as any[]) : [];

      return items
        .filter((item: any) => !!item.powerUp?.key)
        .map((item: any) => {
          const key = item.powerUp.key as string;
          return {
            id: item.id,
            key,
            name: POWERUP_DISPLAY_NAME[key] ?? item.powerUp.name,
            icon: POWERUP_ICON[key] ?? "mdi:puzzle-outline",
            identifier: item.identifier ?? null,
            monthlyCents: item.powerUp.monthlyCents ?? 0,
            isIncluded: item.isIncluded ?? false,
          };
        });
    },
    enabled: computed(() => !!orgId.value),
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
